import { render } from "./accountListInFactory.vue?vue&type=template&id=2b66883b&scoped=true"
import script from "./accountListInFactory.vue?vue&type=script&lang=js"
export * from "./accountListInFactory.vue?vue&type=script&lang=js"

import "./accountListInFactory.vue?vue&type=style&index=0&id=2b66883b&lang=scss&scoped=true"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b66883b"]])

export default __exports__